<script setup lang="ts">
  import type { InputHTMLAttributes } from 'vue'
  import { computed } from 'vue'

  const props = defineProps<{
    value?: InputHTMLAttributes['value'],
    required?: boolean,
    disabled?: boolean,
    indeterminate?: boolean,
  }>()

  const model = defineModel<InputHTMLAttributes['checked']>({ required: true })

  const isIndeterminate = computed(() => {
    return props.indeterminate ?? false
  })
</script>

<template>
  <label
    class="inline-flex items-center"
    :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer']">
    <input
      v-if="value === undefined"
      v-model="model"
      type="checkbox"
      :disabled="disabled"
      class="cursor-pointer peer"
      :required="required ?? false"
      :indeterminate.prop="isIndeterminate">
    <input
      v-else
      v-model="model"
      type="checkbox"
      :value="value"
      :required="required ?? false"
      :disabled="disabled"
      class="peer cursor-pointer"
      :indeterminate.prop="isIndeterminate">

    <div class="checkbox-content">
      <slot></slot>
    </div>
  </label>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  input {
    @apply accent-primary;
  }
  .checkbox-content {
    @apply ml-2 text-sm peer-hover:text-black peer-disabled:opacity-40 peer-hover:peer-disabled:text-current;
  }
  .checkbox-content:empty {
    @apply ml-0;
  }
</style>
